import { SpanProperties } from '../span-progress-entities';

export function calculateSpanLength(lengths: string[]): string {
  const sum = lengths.reduce((accumulator, currentValue) => {
    return accumulator + parseFloat(currentValue);
  }, 0);
  return sum.toString();
}

export function formatSpanLength(length: string): string {
  return parseFloat(length).toFixed(0);
}

export function calculateAndFormatSpanLength(lengths: string[]): string {
  return formatSpanLength(calculateSpanLength(lengths));
}

export const calculateAndFormatSpanLengthFromSpanProperties = (
  spanProperties: SpanProperties[],
): string =>
  calculateAndFormatSpanLength(spanProperties.map(({ length }) => length));
